import React from "react";

import AboutView from "features/new/about/view";
import CalendarViewVariantA from "features/new/calendar/view";
import CalendarViewVariantB from "features/home/calendar/view";
import GetConnectedView from "features/new/get-connected/view";
import Recommendation from "features/new/recommendation/component";
import ExperienceView from "features/new/experience/view";
import Collective from "features/new/collective/component";
import Portal from "features/new/portal";

import "features/new/main/view.scss";

// eslint-disable-next-line react/prop-types
const MainView = ({ innerRef }) => (
  <main className="main" ref={innerRef}>
    <AboutView />
    <CalendarViewVariantA />
    <CalendarViewVariantB />
    <GetConnectedView />
    <Recommendation />
    <ExperienceView />
    <Collective />
    <Portal />
  </main>
);

export default MainView;
